import * as React from "react";

import { Skeleton } from "@/components/ui/skeleton";

/**
 * Spinner — Platzhalter während des Ladens.
 *
 * Zeigt statt eines drehenden Rads die grobe Form des kommenden Inhalts, damit
 * beim Eintreffen nichts springt. Name beibehalten, weil ihn mehrere Stellen
 * importieren.
 */
const Spinner = ({ size }) =>
  size === "small" ? (
    <div className="space-y-[0.6rem] mt-[1.2rem]">
      <Skeleton className="h-[5.6rem] rounded-card" />
      <Skeleton className="h-[5.6rem] rounded-card" />
    </div>
  ) : (
    <div className="space-y-[1.2rem] p-[1.6rem]">
      <Skeleton className="h-[8rem] rounded-card" />
      <Skeleton className="h-[3.6rem] rounded-[0.8rem]" />
      <Skeleton className="h-[3.6rem] rounded-[0.8rem]" />
      <div className="space-y-[0.6rem] pt-[0.8rem]">
        <Skeleton className="h-[5.6rem] rounded-card" />
        <Skeleton className="h-[5.6rem] rounded-card" />
      </div>
    </div>
  );

export default Spinner;
